module.exports = __webpack_public_path__ + "img/bananavw.646c7af9.gif";